// extracted by mini-css-extract-plugin
module.exports = {"main":"Faq-module--main--34muD","faqItem":"Faq-module--faqItem--I7gaz","question":"Faq-module--question--2yR1p","answer":"Faq-module--answer--K5491"};